import React from 'react';
import PropTypes from 'prop-types';
import Button from '../common/Button';
import Tooltip from '../common/Tooltip';
import { getAssessmentTitle } from '../../utils/assessmentUtils';


const ConvertToCustomerDSAButton = ({ dsa, onClick }) => {
  const tooltipText = `
    A Training ${getAssessmentTitle(dsa.type)} can be converted for use with customers and relevant opportunities linked.
  `;

  return (
    <Tooltip position='top' text={tooltipText}>
      <Button
        label={'Convert'}
        onClick={onClick}
      />
    </Tooltip>
  );
};

ConvertToCustomerDSAButton.propTypes = {
  dsa: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired
};

export default ConvertToCustomerDSAButton;



// WEBPACK FOOTER //
// ./src/components/account/ConvertToCustomerDSAButton.js